import { animationToGambleTime } from '@constants/animationTransitionTime'
import { ViewportConfigurations } from './types'
import { ViewportType } from 'game-ui-types'

// Config F [EQ Games] (Bet Stepper)
export const slotConfigF: ViewportConfigurations = {
    [ViewportType.MOBILE_PORTRAIT]: {
        SpinButtonSection: {
            position: { top: '1006px', left: '175px' },
            positionEQ: { top: '1132px', left: '175px' },
            styles: 'gap-[10px] items-center',
        },
        SpinButtonSectionLeftHand: {
            position: { top: '1006px', left: '175px' },
        },
        SpinButtonGambleSection: {
            position: { top: '1127px', left: '175px', transition: `top ${animationToGambleTime}s` },
            styles: 'gap-[10px] items-center',
        },
        SpinButtonGambleSectionLeftHand: {
            position: { top: '1127px', left: '175px', transition: `top ${animationToGambleTime}s` },
        },
        SpinButton: {
            styles: '',
        },
        StopButton: {
            position: { top: '250px', left: '0' },
            styles: 'bg-black fixed w-full h-[35%] z-[0]',
        },
        BetOptionButton: {
            styles: '',
        },
        BetOptionSection: {
            position: { bottom: '450px' },
            styles: 'left-1/2 transform -translate-x-1/2 bg-[#131313]',
        },
        AutoplayButton: {
            styles: '',
        },
        AutoplaySection: {
            position: { bottom: '180px', left: '-18px' },
            styles: 'absolute bg-[#131313]',
        },
        AutoplaySectionLeftHand: {
            position: { bottom: '180px', left: '-18px' },
        },
        SpeedButton: {
            position: { bottom: '-80px', left: '50%' },
            styles: 'absolute translate-x-[-50%]',
        },
        PlayerInfoWrapperClass: { styles: '' },
        PlayerInfoBalance: {
            position: { bottom: '588px', left: '0px' },
            dimensions: { width: '224px' },
            styles: 'ml-[10px]',
        },
        PlayerInfoBalanceJackpot: {
            position: { bottom: '58px', left: '112px' },
            dimensions: { width: '224px' },
            styles: 'ml-0',
        },
        PlayerInfoBalanceGamble: {
            position: { bottom: '136px', left: '8px' },
            dimensions: { width: '250px' },
            styles: 'ml-0 flex-row',
        },
        PlayerInfoLastWin: {
            dimensions: { width: '224px' },
            position: { bottom: '588px', right: '0px' },
            styles: 'flex-col mr-[10px]',
        },
        PlayerInfoLastWinGamble: {
            position: { bottom: '136px', right: '8px' },
            dimensions: { width: '180px' },
            styles: 'ml-0 flex-row justify-end',
        },
        PlayerInfoWinLabel: {
            styles: '',
        },
        PlayerInfoCurrencyLabel: {
            styles: '',
        },
        PlayerInfoLastWinMoneyWrapper: {
            styles: 'flex flex-col items-center',
        },
        PlayerInfoExternalBetAmount: {
            styles: 'rounded-[100px] bg-black/50',
            position: { bottom: '142px', right: '16px' },
            dimensions: { width: '166px', height: '76px' },
        },
        PlayerInfoAdditionalWinAmount: {
            dimensions: { width: '172px' },
        },
        BetStepper: {
            styles: 'absolute left-1/2 transform translate-x-[-50%]',
            position: { bottom: '484px' },
        },
        DoubleChanceButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '146px', left: '16px' },
        },
        BuyBonusButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '146px', right: '16px' },
        },
        PromoWidget: {
            position: { bottom: '146px', left: '16px' },
            dimensions: { width: '132px', height: '168px' },
        },
        Navigation: {
            styles: 'px-[16px] flex justify-between',
            position: { bottom: '56px' },
        },
        NavigationLeftWrapper: {
            styles: '',
        },
        NavigationRightWrapper: {
            styles: 'flex gap-[20px]',
        },
        Compliance: {
            styles: 'px-[8px] flex justify-between text-[14px] leading-[18px]',
        },
        ComplianceColLeft: {
            styles: '',
        },
        ComplianceColCenter: {
            styles: '',
        },
        ComplianceColRight: {
            styles: '',
        },
        CustomResult: {
            position: { top: '202px', left: '5px' },
            styles: 'absolute w-[35px] h-[35px] z-[200]',
        },
        InfoLine: {
            position: { top: '758px' },
            styles: 'absolute h-[94px] w-[324px] flex flex-col justify-center items-center text-center translate-x-[-50%] left-[50%]',
        },
        InfoLineJackpot: {
            position: { top: '955px' },
        },
        InfoLineWinLineWrapper: {
            styles: 'flex gap-[8px] justify-center items-center',
        },
        InfoLineWinAmount: {
            styles: 'text-[24px] leading-[24px] text-white flex items-baseline font-bold',
        },
        InfoLineNumber: {
            styles: 'text-[24px] leading-[24px] text-white text-center font-bold',
        },
        InfoLineText: {
            styles: 'text-[30px] leading-[30px] text-white text-center font-bold',
        },
        InfoLineImageWrapper: {
            dimensions: { width: '36px', height: '36px' },
            styles: 'flex gap-[16px] items-center justify-center',
        },
        InfoLineFreespinText: {
            styles: 'text-[30px] leading-[30px] w-[368px] text-white text-center font-bold whitespace-break-spaces',
        },
        JackpotHistory: {
            position: { top: '170px' },
            dimensions: { height: '1267px' },
        },
        RemainingSpinsBanner: {
            position: { bottom: '488px' },
        },
    },
    [ViewportType.MOBILE_LANDSCAPE]: {
        SpinButtonSection: {
            dimensions: { width: '200px' },
            position: { bottom: '215px', right: '4px' },
            positionEQ: { bottom: '215px', right: '4px' },
            styles: 'flex-col gap-[10px] items-center',
        },
        SpinButtonSectionLeftHand: {
            position: { bottom: '215px', left: '4px' },
        },
        SpinButtonGambleSection: {
            dimensions: { width: '200px' },
            position: { bottom: '215px', right: '4px' },
            styles: 'flex-col gap-[10px] items-center',
        },
        SpinButtonGambleSectionLeftHand: {
            position: { bottom: '215px', left: '4px' },
        },
        SpinButton: {
            styles: '',
        },
        StopButton: {
            position: { top: '75px', left: '197px' },
            styles: 'bg-black fixed w-[72%] h-[75%] z-[0]',
        },
        BetOptionButton: {
            styles: '',
        },
        BetOptionSection: {
            styles: 'top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#131313]',
        },
        AutoplayButton: {
            styles: '',
        },
        AutoplaySection: {
            position: { top: '0', right: '180px' },
            styles: 'absolute bg-[#131313]',
        },
        AutoplaySectionLeftHand: {
            position: { top: '0', left: '180px' },
        },
        SpeedButton: {
            styles: 'z-[51] mt-[-25px] flex',
        },
        PlayerInfoWrapperClass: { styles: '' },
        PlayerInfoBalance: {
            position: { bottom: '25px', left: '290px' },
            dimensions: { width: '224px' },
        },
        PlayerInfoLastWin: {
            dimensions: { width: '224px' },
            position: { bottom: '25px', right: '290px' },
            styles: 'flex-col',
        },
        PlayerInfoWinLabel: {
            styles: '',
        },
        PlayerInfoCurrencyLabel: {
            styles: '',
        },
        PlayerInfoLastWinMoneyWrapper: {
            styles: 'flex flex-col items-center',
        },
        PlayerInfoExternalBetAmount: {
            styles: 'rounded-[100px] bg-black/50',
            position: { bottom: '209px', right: '10px' },
            dimensions: { width: '166px', height: '76px' },
        },
        PlayerInfoAdditionalWinAmount: {
            styles: 'absolute left-1/2 -translate-x-1/2',
            position: { bottom: '70px' },
            dimensions: { width: '172px' },
        },
        BetStepper: {
            styles: 'absolute left-1/2 transform translate-x-[-50%]',
            position: { bottom: '24px' },
        },
        DoubleChanceButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '306px', left: '19px' },
        },
        BuyBonusButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '128px', left: '19px' },
        },
        PromoWidget: {
            position: { top: '78px', left: '19px' },
            dimensions: { width: '132px', height: '168px' },
        },
        Navigation: {
            styles: 'px-[10px] flex justify-between items-end',
            position: { bottom: '27px' },
        },
        NavigationLeftWrapper: {
            styles: '',
        },
        NavigationRightWrapper: {
            styles: 'flex gap-y-[20px] gap-x-[10px]',
        },
        Compliance: {
            styles: 'px-[8px] flex justify-between text-[14px] leading-[18px]',
        },
        ComplianceColLeft: {
            styles: 'flex gap-[30px] flex-row-reverse',
        },
        ComplianceColCenter: {
            styles: 'flex gap-[30px]',
        },
        ComplianceColRight: {
            styles: 'flex gap-[30px]',
        },
        CustomResult: {
            position: { top: '176px', left: '5px' },
            styles: 'absolute w-[50px] h-[50px] z-[200]',
        },
        InfoLine: {
            position: { bottom: '127px' },
            styles: 'absolute h-[36px] w-[810px] flex justify-center items-center text-center translate-x-[-50%] left-[50%] bg-winline-gradient',
        },
        InfoLineJackpot: {
            position: { bottom: '87px' },
        },
        InfoLineWinLineWrapper: {
            styles: 'w-full flex gap-[16px] justify-center items-center',
        },
        InfoLineWinAmount: {
            styles: 'text-[24px] leading-[24px] text-white flex items-baseline font-bold',
        },
        InfoLineNumber: {
            styles: 'text-[24px] leading-[24px] text-white text-center font-bold',
        },
        InfoLineText: {
            styles: 'text-[30px] leading-[36px] text-white text-center font-bold',
        },
        InfoLineImageWrapper: {
            dimensions: { width: '36px', height: '36px' },
            styles: 'flex gap-[16px] items-center justify-center',
        },
        InfoLineFreespinText: {
            styles: 'text-[30px] leading-[36px] text-white text-center font-bold',
        },
        JackpotEQSection: {
            position: {},
        },
        JackpotHistory: {
            position: { top: '72px' },
            dimensions: { height: '738px' },
        },
        RemainingSpinsBanner: {
            position: { bottom: '27px' },
        },
    },
    [ViewportType.DESKTOP]: {
        SpinButtonSection: {
            dimensions: { width: '200px' },
            position: { bottom: '314px', right: '50px' },
            positionEQ: { bottom: '314px', right: '50px' },
            styles: 'flex-col gap-[10px] items-center',
        },
        SpinButtonSectionLeftHand: {
            position: { bottom: '314px', left: '50px' },
        },
        SpinButtonGambleSection: {
            dimensions: { width: '200px' },
            position: { bottom: '357px', right: '50px' },
            styles: 'flex-col gap-[10px] items-center',
        },
        SpinButtonGambleSectionLeftHand: {
            position: { bottom: '314px', left: '50px' },
        },
        SpinButton: {
            styles: '',
        },
        StopButton: {
            position: { top: '105px', left: '230px' },
            styles: 'bg-black fixed w-[76%] h-[74%] z-[0]',
        },
        BetOptionButton: {
            styles: '',
        },
        BetOptionSection: {
            styles: 'top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#131313]',
        },
        AutoplayButton: {
            styles: '',
        },
        AutoplaySection: {
            position: { top: '-7px', right: '180px' },
            styles: 'absolute bg-[#131313]',
        },
        AutoplaySectionLeftHand: {
            position: { top: '0', left: '180px' },
        },
        SpeedButton: {
            styles: 'z-[51] mt-[-25px] flex',
        },
        PlayerInfoWrapperClass: { styles: '' },
        PlayerInfoBalance: {
            position: { bottom: '33px', left: '286px' },
            dimensions: { width: '224px' },
        },
        PlayerInfoLastWin: {
            dimensions: { width: '224px' },
            position: { bottom: '33px', right: '296px' },
            styles: 'flex-col',
        },
        PlayerInfoWinLabel: {
            styles: '',
        },
        PlayerInfoCurrencyLabel: {
            styles: '',
        },
        PlayerInfoLastWinMoneyWrapper: {
            styles: 'flex flex-col items-center',
        },
        PlayerInfoExternalBetAmount: {
            styles: 'rounded-[100px] bg-black/50',
            position: { bottom: '209px', right: '10px' },
            dimensions: { width: '166px', height: '76px' },
        },
        PlayerInfoAdditionalWinAmount: {
            dimensions: { width: '172px' },
        },
        BetStepper: {
            styles: 'absolute left-1/2 transform translate-x-[-50%]',
            position: { bottom: '30px' },
        },
        DoubleChanceButton: {
            dimensions: { width: '141px', height: '176px' },
            position: { bottom: '170px', left: '46px' },
        },
        BuyBonusButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '170px', left: '46px' },
        },
        AmuseBoostButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '170px', left: '46px' },
        },
        PromoWidget: {
            position: { bottom: '350px', left: '46px' },
            dimensions: { width: '132px', height: '168px' },
        },
        Navigation: {
            styles: 'px-[15px] flex justify-between',
            position: { bottom: '34px' },
        },
        NavigationLeftWrapper: {
            styles: 'flex gap-[10px]',
        },
        NavigationRightWrapper: {
            styles: 'flex gap-[10px]',
        },
        Compliance: {
            styles: 'px-[8px] flex justify-between text-[20px] leading-[24px]',
        },
        ComplianceColLeft: {
            styles: 'flex gap-[30px] flex-row-reverse',
        },
        ComplianceColCenter: {
            styles: 'flex gap-[30px]',
        },
        ComplianceColRight: {
            styles: 'flex gap-[30px]',
        },
        CustomResult: {
            position: { top: '233px', left: '5px' },
            styles: 'absolute w-[70px] h-[70px] z-[200]',
        },
        InfoLine: {
            position: { bottom: '132px' },
            styles: 'absolute h-[36px] w-[810px] flex justify-center items-center text-center translate-x-[-50%] left-[50%] bg-winline-gradient',
        },
        InfoLineJackpot: {
            position: { bottom: '97px' },
        },
        InfoLineWinLineWrapper: {
            styles: 'w-full flex gap-[16px] justify-center items-center',
        },
        InfoLineWinAmount: {
            styles: 'text-[24px] leading-[24px] text-white flex items-baseline font-bold',
        },
        InfoLineNumber: {
            styles: 'text-[24px] leading-[24px] text-white text-center font-bold',
        },
        InfoLineText: {
            styles: 'text-[30px] leading-[36px] text-white text-center font-bold',
        },
        InfoLineImageWrapper: {
            dimensions: { width: '36px', height: '36px' },
            styles: 'flex gap-[16px] items-center justify-center',
        },
        InfoLineFreespinText: {
            styles: 'text-[30px] leading-[36px] text-white text-center font-bold',
        },
        JackpotEQSection: {
            position: {},
        },
        JackpotHistory: {
            position: { top: '94px' },
            dimensions: { height: '986px' },
        },
        RemainingSpinsBanner: {
            position: { bottom: '35px' },
        },
    },
}
